document.addEventListener('DOMContentLoaded', () => {
    const windowHeight = window.innerHeight;

    if(document.querySelector('.jsHeader')){
        const body = document.querySelector('body');
        
        window.header = {
            main: document.querySelector('.jsHeader'),
            menu: document.querySelector('.jsHeaderMenu'),

            nav: {
                trigger: document.querySelector('.jsNavTrigger'),
                dropdown: document.querySelector('.jsNavDropdown'),

                toggle: () => {
                    window.header.nav.trigger.classList.toggle('is-active')
                    window.header.nav.dropdown.classList.toggle('is-active')
                },
            },

            search: {
                main: document.querySelector('.jsSearch'),
                dropdown: document.querySelector('.jsSearchDropdown'),
                trigger: document.querySelector('.jsSearchTrigger'),
                reset: document.querySelector('.jsSearchReset'),

                open: () => {
                    window.header.search.main.classList.add('is-open');
                },
                
                close: () => {
                    window.header.search.main.classList.remove('is-open');
                    window.header.search.main.querySelector('.search-input .jsInput').value = '';

                    if(document.querySelector('.jsSearchDropdown .search-dropdown__container')){
                        document.querySelector('.jsSearchDropdown .search-dropdown__container').remove()
                    }
                },
            },

            burger: {
                trigger: document.querySelector('.jsHeaderBurger'),
                
                open: () => {
                    window.header.main.classList.add('is-active')
                    window.header.menu.classList.add('is-active')
                    window.header.burger.trigger.classList.add('is-active')
                    body.classList.add('_backdrop-header');
                },
            }, 

            close: () => {
                window.header.main.classList.remove('is-active')
                window.header.menu.classList.remove('is-active')
                window.header.burger.trigger.classList.remove('is-active')
                body.classList.remove('_backdrop-header');
            }
        };


        window.header.burger.trigger.addEventListener('click', () => {
            if (window.header.main.classList.contains('is-active')) {
                window.header.close();
            } else{
                window.header.burger.open();
            }
        })
 
        document.addEventListener('click', (e) => {
            const target = e.target 
            if (window.header.main.classList.contains('is-active') && (!target.closest('.jsHeader') || target.closest('.jsSearch'))) {
                window.header.close();
            }

            if (window.header.nav.dropdown.classList.contains('is-active') && (!target.closest('.jsNav') || target.closest('.jsSearch'))) {
                window.header.nav.trigger.classList.remove('is-active')
                window.header.nav.dropdown.classList.remove('is-active')
            }

            if (window.header.search.main.classList.contains('is-open') && !target.closest('.jsSearch')) {
                window.header.search.close()
            }

            if(target == document.querySelector('.jsSearchReset')){
                window.header.search.close()
            }

        })

        window.header.nav.trigger.addEventListener('click', () => {
            window.header.nav.toggle();
        })

        window.header.search.trigger.addEventListener('click', () => {
            if(!window.header.search.main.classList.contains('is-open')){
                window.header.search.open()
            } else{
                window.header.search.close()
            }
        })

        

        if(document.querySelector('.jsSearch')){
            let item = window.header.search.main;
            
            check()

            let windowWidth = window.innerWidth;
            var savedWindowWidth = windowWidth;
        
            window.addEventListener("resize", () => {
                windowWidth = window.innerWidth;

                // resize height
                if (savedWindowWidth == windowWidth){
                    return;
                }

                // resize width
                if(savedWindowWidth != windowWidth) {
                    savedWindowWidth = windowWidth;
                    check()
                }
            });
            
            function move(mode){
                let desktop = document.querySelector('.header__nav');
                let mobile = document.querySelector('.header__button');

                if (mode == 'desktop'){
                    desktop.append(item)
                }

                if (mode == 'mobile'){
                    mobile.before(item)
                }
            }

            function check(){
                if (window.innerWidth >= 992) {
                    move('desktop');
                } else {
                    move('mobile');
                }
            }
        }

        if(document.querySelector('.jsNav')) {
            let nav = document.querySelector('.jsNav');
            let list = nav.querySelector('.nav__list');
            let items = list.querySelectorAll('.nav__item');
            let trigger = nav.querySelector('.jsNavTrigger');
            let dropdownInner = nav.querySelector('.nav__dropdown-inner');
            let moreWidth = 24;
            let search = 32 + 24;

            function check(){
                let dropdownLast = dropdownInner.querySelectorAll('.nav__item')[dropdownInner.querySelectorAll('.nav__item').length - 1] ? dropdownInner.querySelectorAll('.nav__item')[dropdownInner.querySelectorAll('.nav__item').length - 1] : '';
                
                if (nav.offsetWidth < list.offsetWidth + search + moreWidth) {
                    // console.log('hide ' + nav.offsetWidth +' ; ' + Number(list.offsetWidth + search + moreWidth));
                    hide()
                } else if (nav.offsetWidth >= Number(list.offsetWidth + dropdownLast.offsetWidth + 24 + search + moreWidth)){
                    // console.log('show ' + nav.offsetWidth +' >= ' + list.offsetWidth + ' + ' + dropdownLast.offsetWidth + ' + ' + 24 + ' + ' + search + ' = ' + Number(list.offsetWidth + dropdownLast.offsetWidth + 24 + search + moreWidth));
                    show()
                }

                if (dropdownInner.querySelector('.nav__item')){
                    trigger.classList.add('is-visible');
                } else{
                    trigger.classList.remove('is-visible');
                }
            }
        
            function hide(){
                items = list.querySelectorAll('.nav__item');
                dropdownInner.append(items[items.length - 1])
        
                check()
            }
        
            function show(){
                let dItems = dropdownInner.querySelectorAll('.nav__item');
                list.append(dItems[dItems.length - 1])
        
                check()
            }
        
            function mobile(){
                if(dropdownInner.querySelector('.nav__item')){
                    let dItems = dropdownInner.querySelectorAll('.nav__item');
        
                    for (let index = 0; index < dItems.length; index++) {
                        const item = dItems[index];
                        list.append(item)
                    }
                }
            }

            function checkWidth(){
                if (window.innerWidth >= 992) {
                    check()
                } else {
                    mobile()
                }
            }

            checkWidth()
       
            window.addEventListener("resize", () => {
                checkWidth()
            });
        }
    }
})
